// DynamicBackendConfigService
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { distinctUntilChanged, switchMap } from 'rxjs/operators';

interface AppSettings {
  apiUrl: string;
}

@Injectable({
  providedIn: 'root'
})
export class DynamicBackendConfigService {

  public extractSecondURL(path) {
    let thirdSlashIndex = path.indexOf('/', path.indexOf('//') + 2);
    
    if (thirdSlashIndex !== -1) {
        let remainingPath = path.substring(thirdSlashIndex + 1);
        
        let parts = remainingPath.split(':');
        
        if (parts.length > 2) {
            let scheme = remainingPath.startsWith('https/') ? 'https:' : 'http:';
            return scheme + remainingPath.substring(remainingPath.indexOf('/'));
        }
    }
   
    return path;
  }

  private apiUrlSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  apiUrl$: Observable<string | null> = this.apiUrlSubject.asObservable().pipe(distinctUntilChanged());

  private settingsLoadedSubject: ReplaySubject<void> = new ReplaySubject<void>(1);
  settingsLoaded$: Observable<void> = this.settingsLoadedSubject.asObservable();

  constructor() {
    this.loadSettings();
  }

  loadSettings(): void {
    fetch('/assets/settings.json')
      .then(response => response.json())
      .then((settings: AppSettings) => {
        this.apiUrlSubject.next(settings?.apiUrl || '');
        this.settingsLoadedSubject.next();
      })
      .catch(error => {
        console.error('Error loading settings:', error);
        this.apiUrlSubject.next(null);
        this.settingsLoadedSubject.next();
      });
  }

  getApiUrl(): Observable<string> {
    return this.settingsLoaded$.pipe(
      switchMap(() => this.apiUrl$)
    );
  }
}